import type { OwnActivity } from "@rosc/contracts";

export type ActivityDay = { key: string; date: Date; visits: number };

const pad = (value: number): string => String(value).padStart(2, "0");
/** The local calendar day of a date, as YYYY-MM-DD. */
export const localDayKey = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/**
 * New visits per local day for the last `days` days, today included, oldest
 * first (days without visits are 0).
 */
export const visitsPerDay = (
  recordings: OwnActivity["recordings"],
  days: number,
  now: Date = new Date(),
): ActivityDay[] => {
  const counts = new Map<string, number>();
  for (const recording of recordings) {
    if (!recording.newVisit) continue;
    const key = localDayKey(new Date(recording.at));
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - (days - 1 - index),
    );
    const key = localDayKey(date);
    return { key, date, visits: counts.get(key) ?? 0 };
  });
};

/** A round axis maximum (at least 4) and its gridline steps. */
export const axisTicks = (max: number): number[] => {
  const top = Math.max(4, max);
  const step = top <= 8 ? 2 : top <= 20 ? 5 : top <= 50 ? 10 : 20;
  const end = Math.ceil(top / step) * step;
  return Array.from({ length: end / step + 1 }, (_, index) => index * step);
};
